import reauthorization from '~/mixins/reauthorization.js';

export default {
  mixins: [reauthorization],
  computed: {
    isInAuth() {
      return this.$route.query.authStep !== undefined;
    },
    isInBenefitActivation() {
      return this.partnerSelected && this.isInAuth;
    },
    isReauthorizationAllowed() {
      return this.partnerData.isReauthorizationAllowed;
    },
    shouldSeePossiblePartners() {
      return (
        this.hasSuggestedPartners &&
        !this.isInAuth &&
        !this.hasBenefitByFamily &&
        !this.hadBenefitBefore &&
        !this.isBenefitEndingInMonth &&
        !this.isPending &&
        !this.$auth.user.benefit.active
      );
    },
    shouldSeeActivePartnerCard() {
      return (
        (this.$auth.user.benefit.active ||
          this.hadBenefitBefore ||
          this.isPending ||
          this.hasBenefitByFamily) &&
        !this.isInAuth
      );
    },
    shouldSeeAuthorization() {
      return (
        !this.$auth.user.benefit.active &&
        this.isAuthorizationCase &&
        !this.hadBenefitBefore &&
        !this.isPending &&
        !this.hasBenefitByFamily &&
        !this.hasSuggestedPartners
      );
    },
    shouldSeeSuggestedPartners() {
      return !this.isInAuth && !this.hasBenefitByFamily;
    },
    shouldSeePartnerSearchInSuggestions() {
      return (
        this.$auth.user?.benefit.active ||
        this.hadBenefitBefore ||
        this.isPending ||
        (this.hasSuggestedPartners &&
          !this.$auth.user?.benefit.active &&
          !this.hadBenefitBefore &&
          !this.isPending)
      );
    },
    isInWarningStateOfBenefit() {
      return this.isBenefitEndingInMonth;
    },
    isInErrorStateOfBenefit() {
      return this.hadBenefitBefore && !this.isPending;
    },
    isInPrimaryStateOfBenefit() {
      return this.isB2C && !this.hadBenefitBefore;
    },
    isEligibleForReAuthorization() {
      return (
        (this.isBenefitEndingInMonth || this.hadBenefitBefore) &&
        !this.hasBenefitByFamily &&
        this.isReauthorizationAllowed
      );
    }
  }
};
